import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const listSkillFichas = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-fichas`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillFichaById = async (id) => {
  const response = await axios.get(`${API_URL}/api/skill-fichas/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const createSkillFicha = async (payload) => {
  const response = await axios.post(`${API_URL}/api/skill-fichas`, payload, {
    headers: authHeaders(),
  });
  return response.data;
};

export const updateSkillFicha = async (id, payload) => {
  const response = await axios.put(
    `${API_URL}/api/skill-fichas/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteSkillFicha = async (id) => {
  const response = await axios.delete(`${API_URL}/api/skill-fichas/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const acquireSkillFichaLock = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-fichas/${id}/lock`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const releaseSkillFichaLock = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-fichas/${id}/unlock`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const heartbeatSkillFichaLock = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-fichas/${id}/heartbeat`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const markSkillFichaDesignComplete = async (id, comentario = "") => {
  const response = await axios.post(
    `${API_URL}/api/skill-fichas/${id}/design-complete`,
    { comentario },
    { headers: authHeaders() },
  );
  return response.data;
};

export const markSkillFichaReady = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-fichas/${id}/mark-ready`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const reopenSkillFichaDesign = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-fichas/${id}/reopen-design`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};
